import { Injectable } from '@angular/core';
import {
    BaseResponseModel,
    CancelDeliveryOrderRequest,
    CancelDeliveryOrderResponse,
    CompleteDeliveryOrderRequest,
    CompleteDeliveryOrderResponse,
    ForceAssignDriverRequest,
    GetDeliveryOrderDetailRequestDto,
    GetLiveMapActiveOrdersResponse,
    GetNearbyDriversForAssignRequest,
    GetNearbyDriversForAssignResponse,
    GetRegionalLiveMapOrdersRequest,
    GetRiderAssigningHistoryRequestDto,
    PrioritizeOrderRequest,
    RiderAssigningHistory,
    XpressDeliveryOrderByGeoZoneDto,
    XpressDeliveryOrderDetail,
    XpressDeliveryOrderListDto
} from '@shared/models';
import { ApiHttp } from 'app/providers';
import { MessageService } from 'primeng/api';

@Injectable()
export class SharedDeliveryOrderService {
	constructor(private apiHttp: ApiHttp) {
	}

	public getDeliveryOrdersByGeoZone(data: XpressDeliveryOrderByGeoZoneDto, messageService: MessageService):
		Promise<XpressDeliveryOrderListDto> {
		return this.apiHttp.post('api/AdminDeliveryOrder/GetDeliveryOrdersByGeoZone', data, messageService);
	}

	public getLiveMapOrders(data: GetRegionalLiveMapOrdersRequest, messageService: MessageService):
		Promise<GetLiveMapActiveOrdersResponse> {
		return this.apiHttp.post('api/RegionalDeliveryOrder/GetLiveMapOrders', data, messageService);
	}

	public exportDeliveryOrdersByZone(data: XpressDeliveryOrderByGeoZoneDto, messageService: MessageService):
		Promise<any> {
		return this.apiHttp.postDownloadFile('api/AdminDeliveryOrder/ExportDeliveryOrdersByZone', data, messageService);
	}

	public getDeliveryOrderDetail(data: GetDeliveryOrderDetailRequestDto, messageService: MessageService):
		Promise<XpressDeliveryOrderDetail> {
		return this.apiHttp.post('api/AdminDeliveryOrder/GetOrderDetail', data, messageService);
	}

	public getCustomerStatistics(data: { UserId: number }, messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/AdminDeliveryOrder/GetCustomerStatistics', data, messageService);
	}

	public getRiderAssigningHistory(data: GetRiderAssigningHistoryRequestDto, messageService: MessageService):
		Promise<RiderAssigningHistory> {
		return this.apiHttp.post('api/AdminDeliveryOrder/GetRiderAssigningHistory', data, messageService);
	}

	public cancelDeliveryOrder(data: CancelDeliveryOrderRequest, messageService: MessageService):
		Promise<CancelDeliveryOrderResponse> {
		return this.apiHttp.post('api/AdminDeliveryOrder/CancelDeliveryOrder', data, messageService);
	}

	public prioritizeOrder(data: PrioritizeOrderRequest, messageService: MessageService):
		Promise<BaseResponseModel> {
		return this.apiHttp.post('api/AdminDeliveryOrder/PrioritizeOrder', data, messageService);
	}

	public completeOrder(data: CompleteDeliveryOrderRequest, messageService: MessageService):
		Promise<CompleteDeliveryOrderResponse> {
		return this.apiHttp.post('api/AdminDeliveryOrder/CompleteOrder', data, messageService);
	}

	public getNearbyDriversForAssign(data: GetNearbyDriversForAssignRequest, messageService: MessageService):
		Promise<GetNearbyDriversForAssignResponse> {
		return this.apiHttp.post('api/AdminDeliveryOrder/GetNearbyDriversForAssign', data, messageService);
	}

	public offerOrderToRider(data: ForceAssignDriverRequest, messageService: MessageService):
		Promise<BaseResponseModel> {
		return this.apiHttp.post('api/AdminDeliveryOrder/OfferOrderToRider', data, messageService);
	}

	public assignScheduledOrderToRider(data: ForceAssignDriverRequest, messageService: MessageService):
		Promise<BaseResponseModel> {
		return this.apiHttp.post('api/AdminDeliveryOrder/AssignScheduledOrderToRider', data, messageService);
	}
}
